import { render, staticRenderFns } from "./stepSaldoCartoesAutomatico.vue?vue&type=template&id=2626bc24"
import script from "./stepSaldoCartoesAutomatico.vue?vue&type=script&lang=ts"
export * from "./stepSaldoCartoesAutomatico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports